import { useEffect, useState } from 'react';
import { useSocket } from './useSocket.js';
import { useGetUnreadCountQuery } from '@/features/notifications/notificationsApi.js';
import { useDispatch } from 'react-redux';
import { notificationsApi } from '@/features/notifications/notificationsApi.js';

export function useNotifications() {
  const { on, connected } = useSocket();
  const dispatch = useDispatch();
  const { data: countData } = useGetUnreadCountQuery();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (countData?.data?.count !== undefined) {
      setUnreadCount(countData.data.count);
    }
  }, [countData]);

  useEffect(() => {
    if (!connected) return;
    const unsub = on('notification:new', (data: any) => {
      if (data.category !== 'message') {
        setUnreadCount((prev) => prev + 1);
      }
      dispatch(notificationsApi.util.invalidateTags(['Notifications']));
    });
    return unsub;
  }, [on, connected, dispatch]);

  return { unreadCount };
}
